import { useEffect, useState } from "react";
import { fetchProgramById } from "../api/programmation";


export function getFirstImageSrc(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const img = doc.querySelector("img");

    return img ? img.src : null;
}



export function getTextFromHTML(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return doc.body.textContent.trim(); // Extract text content and trim whitespace
}



export const initializeWeglot = () => {
    const existingScript = document.querySelector('script[src="https://cdn.weglot.com/weglot.min.js"]');
    if (existingScript) {
        existingScript.remove();
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://cdn.weglot.com/weglot.min.js';
    script.async = true;
    script.onload = () => {
        window.Weglot.initialize({
            api_key: 'wg_c82fb6183fac828dca3d0d09ecbeaa688',
        });
    };
    document.body.appendChild(script);
};





export function useEmissions(programs) {
  const [upcomingEmissions, setUpcomingEmissions] = useState([]);
  const [currentEmission, setCurrentEmission] = useState(null);

  useEffect(() => {
    const fetchEmissions = async () => {
      try {

        const now = new Date();

        // Récupérer les détails des programmes
        const programDetails = await Promise.all(
            programs.map(async (program) => {
                const res = await fetchProgramById(program.id);
                return res.data;
            })
        );

        const allEmissions = [];
        let current = null;

        for (const program of programDetails) {
          for (const emission of program.emissions) {

            const startDateTime = new Date(`${program.dayAt}T${emission.startAt}`);
            const endDateTime = new Date(`${program.dayAt}T${emission.endAt}`);

            emission.startDateTime = startDateTime;
            emission.endDateTime = endDateTime;
            emission.dayAt = program.dayAt;

            allEmissions.push(emission);

            // Vérifier si l'émission est en cours (entre startAt et endAt)
            if (now >= startDateTime && now <= endDateTime) {
              current = emission;
            }
          }
        }

        // Trier les émissions futures par date et heure de début
        const upcoming = allEmissions
          .filter((emission) => emission.startDateTime > now) // Exclure celles déjà commencées
          .sort((a, b) => a.startDateTime - b.startDateTime);

        setUpcomingEmissions(upcoming);
        setCurrentEmission(current);
      } catch (error) {
        console.error("Erreur lors de la récupération des émissions :", error);
      }
    };

    fetchEmissions();
  }, [programs]);

  return { upcomingEmissions, currentEmission };
}